import { cn } from "@/lib/utils";

// 로고가 없는 에이전트의 이니셜 타일 (Figma ver.7 "Logo · 이니셜 타일 (로고 없음)", 10/13 제안 08 · 13).
// 연한 바탕 + 같은 계열의 진한 글자 한 글자. 시안은 에이전트마다 색이 다르지만 고르는 규칙은 정해지지 않아서
// 에이전트 id를 해시해 아래 8색에서 고르게 했어요(같은 에이전트는 어느 화면에서나 같은 색). 규칙이 오면 이 표만 바꿔요.
const TONES: { bg: string; fg: string }[] = [
  { bg: "#E8EEFC", fg: "#1F3A8A" }, // 파랑
  { bg: "#FEF3C7", fg: "#B45309" }, // 호박
  { bg: "#E7F6EF", fg: "#047857" }, // 초록
  { bg: "#F1EBFE", fg: "#7C3AED" }, // 보라
  { bg: "#FDECEF", fg: "#BE123C" }, // 장미
  { bg: "#E3F5F8", fg: "#0E7490" }, // 청록
  { bg: "#EEF7E1", fg: "#4D7C0F" }, // 라임
  { bg: "#E6F4F2", fg: "#0F766E" }, // 틸
];

export function nvInitialToneOf(key: string) {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return TONES[hash % TONES.length];
}

// 이름의 첫 글자 (영문은 대문자). 앞의 [ ] 표식이나 공백은 건너뛰어요.
export function nvInitialOf(name: string) {
  const first = Array.from(name.trim().replace(/^[\s[\](){}"'“”‘’]+/, ""))[0] ?? "?";
  return first.toUpperCase();
}

const VARIANTS = {
  // HOME Certified 행: 40 · r10 · 글자 17/20
  row: "h-10 w-10 rounded-nv-control text-[17px] leading-5",
  // Finder 결과 카드: 로고 박스(56) 안 40 · r8 · 글자 18/22
  card: "h-10 w-10 rounded-nv-chip text-[18px] leading-[22px]",
} as const;

export interface NvInitialTileProps {
  name: string;
  // 색을 고르는 키 (보통 에이전트 id). 없으면 이름
  toneKey?: string;
  variant?: keyof typeof VARIANTS;
  className?: string;
}

export function NvInitialTile({ name, toneKey, variant = "card", className }: NvInitialTileProps) {
  const tone = nvInitialToneOf(toneKey ?? name);
  return (
    <span
      aria-hidden
      style={{ backgroundColor: tone.bg, color: tone.fg }}
      className={cn("flex shrink-0 items-center justify-center font-bold", VARIANTS[variant], className)}
    >
      {nvInitialOf(name)}
    </span>
  );
}
